if (!customElements.get('pause-sticky-purchase')) {
  customElements.define('pause-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      this.main = document.getElementById(`MainProduct-${this.dataset.section}`);
      this.primary = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
      this.button = this.querySelector('[data-purchase-button]');
      if (!this.main || !this.primary) return;
      this.onPurchase = () => {
        if (!this.primary.disabled && this.primary.getAttribute('aria-disabled') !== 'true') this.primary.click();
      };
      this.button.addEventListener('click', this.onPurchase);
      this.update = () => {
        this.button.disabled = this.primary.disabled || this.primary.getAttribute('aria-disabled') === 'true';
        this.button.textContent = !this.button.disabled ? this.main.dataset.addLabel : (this.primary.querySelector('span')?.textContent.trim() || this.primary.textContent.trim());
        const price = this.main.querySelector('[id^="price-"] .price');
        const current = price?.querySelector(price.classList.contains('price--on-sale') ? '.price-item--sale' : '.price-item--regular');
        if (current) this.querySelector('[data-purchase-price]').textContent = current.textContent.trim();
        const variants = this.main.querySelectorAll('variant-selects input:checked, variant-selects select');
        this.querySelector('[data-purchase-variant]').textContent = Array.from(variants, input => input.tagName === 'SELECT' ? input.selectedOptions[0]?.textContent.trim() : input.value).filter(Boolean).join(' / ');
        const error = this.main.querySelector('.product-form__error-message-wrapper');
        this.querySelector('[data-purchase-error]').textContent = error && !error.hidden ? error.textContent.trim() : '';
      };
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.update();
      });
      this.observer.observe(this.main, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'hidden', 'class'] });
      this.main.addEventListener('change', this.update);
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const visible = this.primary.getBoundingClientRect().bottom < 0;
          this.hidden = !visible;
          document.body.classList.toggle('pause-purchase-visible', visible);
          const preview = document.getElementById('PBarNextFrameWrapper');
          const rect = preview?.getBoundingClientRect();
          const offset = rect && rect.height && rect.top < innerHeight && getComputedStyle(preview).visibility !== 'hidden' ? Math.max(0, innerHeight - rect.top) : 0;
          this.style.setProperty('--pause-preview-offset', `${offset}px`);
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.update();
      this.onScroll();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.main?.removeEventListener('change', this.update);
      this.button?.removeEventListener('click', this.onPurchase);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      cancelAnimationFrame(this.frame);
      document.body.classList.remove('pause-purchase-visible');
    }
  });
}


